import Container from 'components/Container/Container';

export default Container;
